import { ReactElement } from 'react';
import { DrawerRowValue } from './DrawerRowValue';
import { DrawerRowText } from './DrawerRowText';

export const DrawerRow = ({
    as: As = 'label',
    children,
}: {
    as?: 'label' | 'div';
    children: ReactElement<typeof DrawerRowText | typeof DrawerRowValue>[];
}) => {
    return (
        <>
            <As className="grid grid-cols-2 min-h-[42px] text-base items-center gap-4">
                {children}
            </As>
            <div className="drawer-row-border pt-3 mb-3 border-b border-gray-200" />
        </>
    );
};
